import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import applyFormTheme from './applyFormTheme';
import { formThemeShape } from './PropTypes';
import style from './FormContent.scss';

const FormContent = ({ className, horizontal, ...props }, { formTheme }) => {
  const theme = applyFormTheme(formTheme, { horizontal });
  return (
    <div
      className={classNames(
        style['form-content'],
        theme.horizontal && style['form-content--horizontal'],
        className
      )}
      {...props}
    />
  );
};

FormContent.propTypes = {
  className: PropTypes.string,
  horizontal: PropTypes.bool,
};

FormContent.contextTypes = {
  formTheme: formThemeShape,
};

export default FormContent;
